import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import { usePreviewCourse } from "../../hooks/usePreviewCourse";
import noAvatarImage from "../../../../../imagenes/no_avatar.svg";
import { useAccount } from "../../../../../../hooks/useAccount";
import { RichTypography } from "../../../../../common/RichTypography/RichTypography";

export function CourseInstructor() {
	const { course } = usePreviewCourse();
	const { account } = useAccount();

	if (!course) {
		return null;
	}

	let introduction = "No intro yet.";
	if (course.teacher?.profile?.introduction) {
		const introductionArr = course.teacher.profile.introduction
			.trim()
			.split(/\s+/);
		const length = introductionArr.length;
		if (length > 50) {
			introduction = `${introductionArr.slice(0, 50).join(" ")}...`;
		} else {
			introduction = introductionArr.slice(0, 50).join(" ");
		}
	}

	return (
		<>
			<div id="instructor-info" className="section-scroll-position" />
			<div className="course-instructor-container" id="instructor-info">
				<Typography className="big-text black-label">
					Meet Your Instructor
				</Typography>
				<div className="course-instructor-content">
					{course.teacher?.profile?.url && (
						<img
							className="avatar"
							src={
								course.teacher.profile.thumbnail || course.teacher.profile.url
							}
						/>
					)}
					{!course.teacher?.profile?.url && (
						<img className="avatar" src={noAvatarImage} />
					)}
					<div style={{ flex: 1, minWidth: "calc(min(100%, 300px))" }}>
						<div>
							<Typography component="span" className="small-title-text bold">
								{`${course.teacher?.firstName ?? ""} ${course.teacher?.lastName ?? ""}`.trim()}
							</Typography>
							{course.teacher?.profile?.nickName && (
								<Typography component="span" className="normal-text">
									{` (${course.teacher.profile.nickName})`}
								</Typography>
							)}
						</div>
						<RichTypography
							id="intro"
							className="normal-text"
							textAlign="justify"
							text={introduction}
						/>
						<Link
							to={`/profile/${course.teacher?.profile?.profileSlug}`}
							className="normal-text">
							Show More
						</Link>
					</div>
				</div>
				{account?.userId !== course.teacher?.userId && (
					<>
						<div className="separator" />
						<Typography className="big-text black-label">
							Still have questions?
						</Typography>
						<Link to={`/messages/${course.teacher?.userId}`}>
							<Button className="normal-button black-button message-instructor-button">
								Message Instructor
							</Button>
						</Link>
					</>
				)}
			</div>
		</>
	);
}
